import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../common/Button";
import Toast from "../common/Toast";
import { BtnIcon, TickIcon } from "../Icons";
import PriceTag from "../../assets/course-details/price-tag.svg";



const PricingCard = ({
  livePrice = "$299",
  recordedPrice = "$199",
  liveFeatures = [
    "Interactive sessions with instructor",
    "Real-time Q&A and discussions",
    "Scheduled daily classes",
    "Certificate upon completion",
  ],
  recordedFeatures = [
    "Learn at your own pace",
    "High-quality video lessons",
    "4 Months access to content",
    "Certificate upon completion",
  ],
  onBuy = () => {},
  onDemo = () => {},
  showToast = false,
  buyTo,
  buyState,
  demoTo,
}) => {
  const navigate = useNavigate();
  const [toast, setToast] = useState({
    show: false,
    title: "",
    message: "",
  });

  const handleBuyClick = () => {
    onBuy();
    if (showToast) {
      setToast({
        show: true,
        title: "Login Required",
        message: "Create an account or log in to buy the course",
      });
      return;
    }
    if (buyTo) {
      navigate(buyTo, buyState != null ? { state: buyState } : undefined);
      return;
    }
    navigate("/student/buy-course");
  };

  const handleDemoClick = () => {
    onDemo();
    if (showToast) {
      setToast({
        show: true,
        title: "Login Required",
        message: "Create an account or log in to schedule your free demo session",
      });
      return;
    }
    if (demoTo) {
      navigate(demoTo);
    }
  };

  return (
    <>
      <div className="w-full max-w-[567px] rounded-[18px] bg-white px-6 pb-10 pt-8 shadow-[0_0_9.8px_1px_#00000040] 2xl:px-12 2xl:pb-20 2xl:pt-14">
        <div className="flex flex-col gap-4 sm:gap-7">
          <Button
            btnText="Buy Now"
            onClick={handleBuyClick}
            btnClassName={
              "bg-[#FF6636] w-full hover:bg-opacity-15 hover:text-[#FF6636]    font-medium text-sm sm:text-base text-white px-9 py-3 sm:py-4"
            }
          />

          <Button
            icon={BtnIcon}
            btnText="Book a Free Demo"
            onClick={handleDemoClick}
            btnClassName={
              "bg-[#E881051A] hover:bg-opacity-15 hover:text-[#FF6636] tracking-[-1%]   flex-row-reverse gap-1 sm:gap-3 font-semibold text-base sm:text-lg text-[#FF6636] w-full px-9 py-2.5 sm:py-[14px]"
            }
          />
        </div>

        <div className="mt-[38px]">
          <div className="flex items-center justify-between text-black">
            <h4 className="text-lg sm:text-xl leading-5 sm:leading-6 font-bold">In Live Sessions</h4>
            <p className="text-base sm:text-lg font-medium leading-4 sm:leading-5 flex gap-1.5">
              <img src={PriceTag} alt="tag" /> {livePrice}
            </p>
          </div>

          <ul className="mt-6 sm:mt-9 space-y-5">
            {liveFeatures.map((f, i) => (
              <li key={i} className="flex items-center gap-3 sm:gap-5">
                <TickIcon />

                <p className="text-black text-base sm:text-xl">{f}</p>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-9">
          <div className="flex items-center justify-between text-black">
            <h4 className="text-lg sm:text-xl leading-5 sm:leading-6 font-bold">In Recorded Sessions</h4>
            <p className="text-base sm:text-lg font-medium leading-4 sm:leading-5 flex gap-1.5">
              <img src={PriceTag} alt="tag" /> {recordedPrice}
            </p>
          </div>

          <ul className="mt-6 space-y-5">
            {recordedFeatures.map((f, i) => (
              <li key={i} className="flex items-center gap-5">
                <TickIcon />

                <p className="text-black text-base sm:text-xl">{f}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {toast.show && (
        <Toast
          title={toast.title}
          message={toast.message}
          onClose={() => setToast((prev) => ({ ...prev, show: false }))}
        />
      )}
    </>
  );
};

export default PricingCard;
